/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext } from 'react';
import MobileContext from 'context/MobileContext';
import styles from './style.module.css';
import fsfLogo from '../../../assets/newIcons/FSFhorizontalLogo.svg';

const Header = () => {
  const isMobile = useContext(MobileContext);

  return (
    <>
      <div className={`${styles.wrapper} ${isMobile ? styles.mob : ''}`}>
        <img alt='' src={fsfLogo} className={styles.logo} />
      </div>
    </>
  );
};

export default Header;
